export default {
   urlToApi: '/api/',
   urlToServer: '/',
   urlToWs: '/',
 }
